import styled from "styled-components";

export const MainContainer = styled.div<{ backgroundImage?: string }>`
    background-image: ${({ backgroundImage }) => (backgroundImage ? `url(${backgroundImage})` : "none")};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;
